<script setup>
import {onMounted, ref, reactive} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import moment from "moment";
import YTTagsState from "@/components/YTTagsState/index.vue"
import router from "@/router/index.js";
import {tagsStateEnum} from "@/enum/tagsStateEnum.js";
import {addTagsNew, editTagsNew, editTagsStateNew, tagsListNew} from "@/api/tag/tag.js";
/*初次加载*/
onMounted(async () => {
  await handleSearch()
})

/*搜索功能*/
// 表单数据
const formData = reactive({
  tagName: null,
  state: null,
});
// 根据表单搜索信息
const handleSearch = async (mode = 'init') => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const page = {
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    }
    let param = {
      tagName: formData.tagName,
      state: formData.state === null ? null : formData.state,
    }
    console.log("param", param)
    loading.value = true
    const res = await tagsListNew(page, param)
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.tagName = null
  formData.state = null
  handleSearch('btnSearch')
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
// 表头信息
const headers = ref([
  { title: '序号', key: 'order', nowrap: true },
  { title: '标签名称', key: 'tagName', nowrap: true },
  { title: '图标', key: 'icon', nowrap: true },
  { title: '状态', key: 'state', nowrap: true },
  { title: '操作', key: 'controls', width: "100px", fixed: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

// 是否为编辑状态
const isEdit = ref(false)
// 是否为禁用状态
const isDisabled = ref(false)
// 是否为启用状态
const isEnabled = ref(false)
// 处理编辑标签
const handleEdit = (item) => {
  open.value = true
  dialogForm.tagId = item.tagId
  dialogForm.tagName = item.tagName
  dialogForm.tagNameEn = item.tagNameEn
  dialogForm.tagNameChange = item.tagNameChange
  dialogForm.tagNameEnChange = item.tagNameEnChange
  isEdit.value = true
  dialogRules.value = rulesTwo
}
// 处理启用/禁用
const handleState = (item, type) => {
  dialogForm.tagId = item.tagId
  dialogForm.tagName = item.tagName
  dialogForm.tagNameEn = item.tagNameEn
  if (type === "enable") {
    isEnabled.value = true
    open.value = true
    dialogRules.value = rulesThree
  } else {
    isDisabled.value = true
    open.value = true
    dialogRules.value = rulesThree
  }
}

// 处理添加新标签
const handleAdd = () => {
  open.value = true
  dialogRules.value = rulesOne
  dialogFormRef.value.clearValidate()
}

// 标签状态枚举
const tagsState = ref(tagsStateEnum)

// 标签名称校验规则
const checkTagName = (rule, value, callback) => {
  if (!dialogForm.tagName) {
    return callback(new Error("标签名称（中文）不能为空！"))
  }
  if (!dialogForm.tagNameEn) {
    return callback(new Error("标签名称（English）不能为空！"))
  }
  return callback()
}
// 标签名称校验规则
const checkTagNameChange = (rule, value, callback) => {
  if (!dialogForm.tagNameChange) {
    return callback(new Error("标签名称（中文）不能为空！"))
  }
  if (!dialogForm.tagNameEnChange) {
    return callback(new Error("标签名称（English）不能为空！"))
  }
  return callback()
}
/*弹窗相关*/
// 弹窗表单锚点
const dialogFormRef = ref()
// 弹窗表单
const dialogForm = reactive({
  tagId: null,
  tagName: null,
  tagNameEn: null,
  tagNameChange: null,
  tagNameEnChange: null,
  applicationReason: null,
})
// 创建标签表单校验规则
const rulesOne = {
  tagName: [
    {required: true, validator: checkTagName, trigger: "blur"}
  ]
}
// 编辑表单校验规则
const rulesTwo = {
  tagNameChange: [
    {required: true, validator: checkTagNameChange, trigger: "blur"}
  ],
  applicationReason: [
    {required: true, message: "请填写原因", trigger: "blur"}
  ]
}
// 禁用表单校验规则
const rulesThree = {
  applicationReason: [
    {required: true, message: "请填写原因", trigger: "blur"}
  ]
}
// 弹窗表单校验规则
const dialogRules = ref(rulesOne)
// 关闭新增标签弹窗表单
const closeDialog = () => {
  open.value = false
  dialogForm.tagId = null
  dialogForm.tagName = null
  dialogForm.tagNameEn = null
  dialogForm.tagNameChange = null
  dialogForm.tagNameEnChange = null
  dialogForm.applicationReason = null
  tagNameTab.value = "zh"
  isEdit.value = false
  isDisabled.value = false
  isEnabled.value = false
  dialogFormRef.value.clearValidate()
}
// 提交新增标签表单
const submitDialog = async () => {
  dialogFormRef.value.validate(async (valid) => {
    if (valid) {
      try {
        loading.value = true
        if (isEdit.value) {
          let param = {
            tagName: dialogForm.tagNameChange,
            tagNameEn: dialogForm.tagNameEnChange,
            applicationReason: dialogForm.applicationReason
          }
          await editTagsNew(dialogForm.tagId, param)
          ElMessage.success("修改申请提交成功")
        } else if (isEnabled.value) {
          // 启用
          let param = {
            tagId: dialogForm.tagId,
            state: 1,
            applicationReason: dialogForm.applicationReason
          }
          await editTagsStateNew(param)
          ElMessage.success("启用申请提交成功")
        } else if (isDisabled.value) {
          // 禁用
          let param = {
            tagId: dialogForm.tagId,
            state: 0,
            applicationReason: dialogForm.applicationReason
          }
          await editTagsStateNew(param)
          ElMessage.success("禁用申请提交成功")
        } else if (!isDisabled.value && !isEdit.value && !isEnabled.value) {
          let param = {
            tagName: dialogForm.tagName,
            tagNameEn: dialogForm.tagNameEn
          }
          await addTagsNew(param)
          ElMessage.success("新增申请提交成功")
        }
        closeDialog()
        await handleSearch()
        loading.value = false
      } catch (e) {
        console.log(e)
        loading.value = false
      }
    } else {
      ElMessage({
        message: "请根据提示修改表单信息",
        type: "error",
      })
    }
  })

}
// 创建标签弹窗打开状态
const open = ref(false)
/*中英文切换输入框相关Tab*/
// 商品标签tab
const tagNameTab = ref("zh")
</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 16px">
    <div class="flex_left" style="padding-left: 16px;">
      <v-btn color="success" @click="handleAdd">
        <template v-slot:default>
          <div class="flex_bt">
            <img
                style="width: 14px; height: 14px; margin-right: 4px"
                src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/filter/filter/plus.svg"
            />
            <span>新标签</span>
          </div>
        </template>
      </v-btn>
    </div>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="11">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:top>
            <v-form>
              <v-container>
                <v-row justify="center">
                  <v-col cols="3">
                    <v-text-field
                        v-model="formData.tagName"
                        placeholder="请输入标签名称"
                        label="标签名称"
                        variant="outlined"
                        clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-select
                        v-model="formData.state"
                        placeholder="选择标签状态"
                        variant="outlined"
                        label="标签状态"
                        clearable
                        :items="tagsState"
                        item-title="stateName"
                        item-value="stateId"
                    ></v-select>
                  </v-col>
                  <v-col cols="3" offset="3">
                    <v-row justify="end">
                      <v-col class="flex_right" cols="6">
                        <v-btn color="success" size="large" @click="handleSearch('btnSearch')">搜索</v-btn>
                      </v-col>
                      <v-col class="flex_right" cols="6">
                        <v-btn size="large" @click="handleReset">重置</v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </template>

          <template v-slot:item.order=" { item, index } ">
            {{index + 1}}
          </template>

          <template v-slot:item.icon=" { item }">
            <div v-if="item.icon">
              <v-icon icon="mdi-check" size="16"></v-icon>
            </div>
          </template>

          <template v-slot:item.crUserName=" { item } ">
            {{item.type === 'SYSTEM' ? 'System' : item.crUserName}}
          </template>

          <template v-slot:item.state="{ item }">
            <YTTagsState :state="item.state"></YTTagsState>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left">
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="编辑"
                  placement="left">
                <v-icon v-if="item.state === 3" class="mg_r_1 cursor-pointer" icon="mdi-file-edit-outline" color="primary" size="small" @click="handleEdit(item)"></v-icon>
              </el-tooltip>
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="启用"
                  placement="top">
                <v-icon v-if="item.state === 0" class="mg_r_1 cursor-pointer" icon="mdi-arrow-up-thin-circle-outline" color="success" @click="handleState(item, 'enable')"></v-icon>
              </el-tooltip>
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="禁用"
                  placement="top">
                <v-icon v-if="item.state === 1" class="mg_r_1 cursor-pointer" icon="mdi-circle-off-outline" color="error" @click="handleState(item, 'disabled')"></v-icon>
              </el-tooltip>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :pageSize="$globalPageSizeHalf" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
  <el-dialog
      v-model="open"
      width="600"
      style="padding: 20px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
    <template #header>
      <div style="padding: 16px 24px;font-size: 1.25rem;font-weight: 500;text-align: left;color: #000000">{{isEdit ? '编辑' : isDisabled ? '禁用' : isEnabled ? '启用' :'新增'}}标签</div>
    </template>
    <el-form
        ref="dialogFormRef"
        style="max-width: 100%;"
        :model="dialogForm"
        :rules="dialogRules"
        label-width="auto"
        class="demo-ruleForm"
        size="large"
        status-icon
        v-loading="loading"
        id="dialogForm"
    >
      <div class="mg_b_2" v-if="isEdit || isDisabled" style="text-align: left">
        标签名称：{{dialogForm.tagName}}
      </div>
      <el-form-item label="标签名称：" prop="tagName" v-if="!isEdit && !isDisabled && !isEnabled">
        <el-tabs
            v-model="tagNameTab"
            type="card"
            class="demo-tabs"
        >
          <el-tab-pane label="中文" name="zh">
            <el-input show-word-limit maxlength="30" v-model="dialogForm.tagName" placeholder="请勿超过30个字符"></el-input>
          </el-tab-pane>
          <el-tab-pane label="English" name="en">
            <el-input show-word-limit maxlength="120" v-model="dialogForm.tagNameEn" placeholder="Do not exceed 120 characters"></el-input>
          </el-tab-pane>
        </el-tabs>
      </el-form-item>
      <el-form-item label="标签名称更改：" prop="tagNameChange" v-if="isEdit">
        <el-tabs
            v-model="tagNameTab"
            type="card"
            class="demo-tabs"
        >
          <el-tab-pane label="中文" name="zh">
            <el-input show-word-limit maxlength="30" v-model="dialogForm.tagNameChange" placeholder="请勿超过30个字符"></el-input>
          </el-tab-pane>
          <el-tab-pane label="English" name="en">
            <el-input show-word-limit maxlength="120" v-model="dialogForm.tagNameEnChange" placeholder="Do not exceed 120 characters"></el-input>
          </el-tab-pane>
        </el-tabs>
      </el-form-item>
      <el-form-item label="申请原因：" prop="applicationReason" v-if="isEdit || isDisabled || isEnabled">
        <el-input show-word-limit maxlength="20" v-model="dialogForm.applicationReason" placeholder="请填写原因，20个字符内"></el-input>
      </el-form-item>
      <div class="flex_center flex_left" v-if="!isDisabled && !isEdit && !isEnabled">
        <img
            style="width: 18px; height: 18px; margin-right: 10px"
            src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/common/common/tips.svg"
        />
        <div>带有图标的标签，请交给开发同事创建。</div>
      </div>
      <div v-if="isDisabled" style="text-align: left">
        您正在提交禁用标签申请，请填写原因，并复核后再提交。
      </div>
      <div v-if="isEnabled" style="text-align: left">
        您正在提交启用标签申请，请填写原因，并复核后再提交。
      </div>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <v-row>
          <v-col cols="5" offset="7">
            <div class="flex_right">
              <v-btn variant="elevated" @click="closeDialog">取消</v-btn>
              <v-btn class="mg_l_1" color="primary" variant="elevated" @click="submitDialog">提交</v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </el-dialog>
</template>

<style scoped>

</style>
